<template>
  <div v-if="show" class="card card-material card-finish">
    <div @click="openFilter()" class="card-body pb-0 card-material" :class="{ 'active': isActive }">
      <div class="card-title card-material-title" :class="{ 'clear-select': finish }">
        Kantafwerking
        <template v-if="isHPL()"><small>(bijpassed bij zijde 1)</small></template>
        <div v-if="finish" class="badge badge-selected float-right">{{ selectedName }}</div>
        <font-awesome-icon v-if="showFilter && finish" class="font-awesome-icon action angle-up hidefilter" v-on:click.stop.prevent="hideFilter" icon="angle-up"/>
      </div>

      <div v-if="showFilter" class="select-type row">
        <div v-for="finish in finishes" v-bind:key="finish.id" v-on:click.stop.prevent="selectFinish(finish)" class="card card-select card-body m-md-1" :class="{'col-md-13': finishes.length === 1, 'col-md-6': finishes.length > 1, 'selected': finish.shortName === selectedName}">
          <div class="card-type">
            <span v-html="finish.name"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { SET_MATERIAL_FINISH, SET_DISABLE_PANEL_INPUT } from '../../../store/types'
  import { EventBus } from '../../../bus'

  export default {
    data() {
      return {
        showFilter: false
      }
    },
    computed: {
      materialBruto() {
        return this.$store.getters.materialBruto
      },
      finishes() {
        // Get the selected product
        if (this.thickness) {
          let dimensions = this.$store.getters.materialDimensions
          let materialThickness = dimensions.total_thickness

          let code = this.$store.getters.materialCode
          let product = this.$store.getters.product(parseInt(code))
          if (this.$store.getters.filterFirst.indexOf('HPL') !== -1) {
            // Get the first toplayer for the correct finishes
            product = !this.$store.getters.materialSide1 ? product : this.$store.getters.materialSide1
          }

          let options = []
          if (!product) {
            // We do not have products yet...
            return options
          }

          if (this.$store.getters.filterDeliveryProgram === 'Meubelpanelen') {
            options.push({id: 2, name: '1-LZ 2 mm ABS /<br/> 1-LZ 0.4 mm ABS<br/>(lasertech)', shortName: '1-LZ 2 MM ABS / 1-LZ 0.4 MM ABS', code: 'LASERTECH2'})
            if (product.filter_3.indexOf('W1000/9') !== -1) {
              options.push({id: 1, name: '1-LZ 1 mm ABS /<br/> 1-LZ 0.4 mm ABS<br/>(lasertech)', shortName: '1-LZ 1 MM ABS / 1-LZBS 0.4 MM ABS', code: 'LASERTECH1'})
            }
          } else if (this.materialBruto) {
            // Niet mogelijk bij bruto platen
            options.push({ id: 0, name: 'Niet mogelijk', shortName: 'Niet mogelijk', code: 'np' })
          } else {
            if (!product.abs1 && !product.abs2 && !product.veneer1 && !product.veneer2 && !product.base_tape) {
              options.push({ id: 0, name: 'Niet mogelijk', shortName: 'Niet mogelijk', code: 'np' })
            } else if (materialThickness < 9.6) {
              options.push({ id: 0, name: 'Niet mogelijk', shortName: 'Niet mogelijk', code: 'np' })
            } else if (this.$store.getters.filterDeliveryProgram === 'Easy W' && materialThickness < 17) {
              // Uitzondering voor dunne panelen van easywhite
              options.push({ id: 0, name: 'Niet mogelijk', shortName: 'Niet mogelijk', code: 'np' })
            } else {
              // Deze optie tonen als materiaal-dikte < gevonden kantenband dikte
              if (product.abs1 > 0 && product.abs1 >= materialThickness + 3.4) {
                options.push({id: 1, name: 'ABS 1 mm', shortName: 'ABS 1 MM', code: 'ABS1'})
              }
              if (product.abs2 > 0 && product.abs2 >= materialThickness + 3.4) {
                options.push({id: 2, name: 'ABS 2 mm', shortName: 'ABS 2 MM', code: 'ABS2'})
              }
              if (product.veneer1 > 0 && product.veneer1 >= materialThickness + 3.4) {
                options.push({id: 3, name: 'FINEER 1 mm', shortName: 'FINEER 1 MM', code: 'FINEER1'})
              }
              if (product.veneer2 > 0 && product.veneer2 >= materialThickness + 3.4) {
                options.push({id: 4, name: 'FINEER 2 mm', shortName: 'FINEER 2 MM', code: 'FINEER2'})
              }
              if (product.base_tape > 0 && product.base_tape >= materialThickness + 3.4) {
                options.push({id: 5, name: 'Grondeerband 2 mm', shortName: 'Grondeerband 2 MM', code: 'GRONDEERBAND2'})
              }

              options.push({id: 0, name: 'Geen', shortName: 'Geen', code: 'none'})
            }
          }
          return options
        }

        return [{ id: 0, name: 'Niet mogelijk', shortName: 'Niet mogelijk', code: 'np' }]
      },
      thickness() {
        return !this.$store.getters.materialThickness ? false : this.$store.getters.materialThickness
      },
      show() {
        if (this.materialBruto) {
          return false
        } else if (this.$store.getters.filterFirst && this.$store.getters.filterFirst.indexOf('HPL') !== -1) {
          return !this.$store.getters.material.side2 ? false : this.$store.getters.material.side2
        } else {
          return !this.$store.getters.materialThickness ? false : this.$store.getters.materialThickness
        }
      },
      isActive() {
        if (this.$store.getters.filterFirst && this.$store.getters.filterFirst.indexOf('HPL') !== -1) {
          return this.$store.getters.material.side1 && this.$store.getters.material.side2 && (this.showFilter || !this.finish)
        } else {
          return this.showFilter || !this.finish
        }
      },
      finish() {
        return !this.$store.getters.materialFinish ? false : this.$store.getters.materialFinish
      },
      selectedName() {
        if (this.finish) {
          return this.finish.shortName
        }

        return ''
      }
    },
    methods: {
      isHPL() {
        return this.$store.getters.filterFirst ? this.$store.getters.filterFirst.indexOf('HPL') !== -1 : false
      },
      selectFinish(select) {
        if (select !== this.finish) {
          this.$store.dispatch(SET_MATERIAL_FINISH, select)

          EventBus.$emit('validate-row')
        }
        this.showFilter = false

        this.$store.dispatch(SET_DISABLE_PANEL_INPUT)
      },
      openFilter() {
        if (this.finish && this.showFilter) {
          this.showFilter = false
        } else {
          this.showFilter = true
        }
      },
      hideFilter() {
        if (this.finish) {
          this.showFilter = false
        }
      }
    },
    updated() {
      if (this.finishes) {
        if (this.$store.getters.filterDeliveryProgram === 'Meubelpanelen' && this.finishes.length === 1) {
          // For Meubelpanelen: If only 1 option is left, just pre-select the item, and move on
          this.selectFinish(this.finishes[0])
        } else if (this.finishes[0].code === 'np' && this.finish.code !== 'np') {
          // Only the option 'Niet mogelijk' is possible, select it, if not already selected
          this.selectFinish(this.finishes[0])
        } else if (this.finishes.length === 1 && this.finishes[0].code === 'none' && this.finish.code !== 'none') {
          // Only the option 'Niet mogelijk' is possible, select it, if not already selected
          this.selectFinish(this.finishes[0])
        } else if (this.finish.code && this.finishes.filter(option => option.code === this.finish.code).length === 0) {
          // selected option no longer available, unselect it
          this.selectFinish(null)
        } else {
          // Leave all other options selected
        }
      }

      this.showFilter = (this.$store.getters.loadingMaterial) ? false : (!this.finish) ? true : this.showFilter
    },
    created() {
      this.showFilter = !this.finish

      EventBus.$on('reset-finish-selection', data => {
        // Set/Reset selection
        // if (this.finishes) {
        //   if (this.finishes[0].code === 'np' && (!this.finish || this.finish.code !== 'np')) {
        //     // Only the option 'Niet mogelijk' is possible, select it, if not already selected
        //     // this.selectFinish(this.finishes[0])
        //   } else if (this.finish.code && this.finishes.filter(option => option.code === this.finish.code).length === 0) {
        //     // selected option no longer available, unselect it
        //     this.selectFinish(null)
        //   } else {
        //     // Leave all other options selected
        //   }
        // }
      })
    }
  }
</script>

<style lang="scss" scoped>
  .card-title {
    font-weight: bold;
  }

  .card-type {
    text-align: center;
    font-weight: bold;
    font-size: 0.9em
  }
</style>
